module.exports = __webpack_public_path__ + "img/s1-4.44ec0789.jpeg";